import React, { useContext, useState } from 'react'
import { Container } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import { NavLink, useLocation } from 'react-router-dom'
import { Button, NavTabs } from '@abroad/components'
import PageHeader from './PageHeader'
import { CompanyEcoSearch, UpsertCompanyEcoModal } from '../company'
import { Table, TableInstance } from '../table'
import { ListingFiltersContext } from '../../utils/contexts'

const OrgEcoListingTable = ({
  columns,
  data,
  label,
  sortById,
  search,
  fetchData,
  isLoading,
  hasMore,
  type,
  basePath,
}) => {
  const title = `${label} | Abroad`
  const [showAddCompanyEcoModal, setShowAddCompanyEcoModal] = useState(false)
  const { filters } = useContext(ListingFiltersContext)
  const location = useLocation()
  const isArchivedTab = location?.pathname === `${basePath}/archive`
  const listingPages = [
    {
      path: `${basePath}/active`,
      name: 'Active',
      defaultUrl: basePath,
    },
    {
      path: `${basePath}/archive`,
      name: 'Archive',
    },
  ]

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name='title' content={title}></meta>
        <meta property='og:title' content={title}></meta>
        <meta property='twitter:title' content={title}></meta>
        <link
          rel='canonical'
          href={`${
            process.env.REACT_APP_DOMAIN
          }/admin/${label?.toLowerCase()}`}></link>
        <meta
          property='og:url'
          content={`${
            process.env.REACT_APP_DOMAIN
          }/admin/${label?.toLowerCase()}`}></meta>
        <meta
          property='twitter:url'
          content={`${
            process.env.REACT_APP_DOMAIN
          }/admin/${label?.toLowerCase()}`}></meta>
      </Helmet>
      <TableInstance
        columns={columns}
        data={data}
        initialState={{
          globalFilter: {
            search: search || filters?.search,
          },
          sortBy: [{ id: sortById, desc: filters?.sort === 'DESC' }],
        }}>
        {({
          preGlobalFilteredRows,
          state: { globalFilter, ...other },
          setGlobalFilter,
          ...rest
        }) => (
          <>
            <PageHeader
              titleText={label}
              titleClasses='s2 custom-mb-0-625 sentence-case-text'
              wrapperClassName='d-flex justify-content-between mb-0'
              descriptionFn={() => {
                return (
                  <div className='d-flex'>
                    <div className='profile d-flex flex-grow-1'>
                      <CompanyEcoSearch
                        {...{
                          globalFilter,
                          setGlobalFilter,
                        }}
                        placeholder={`Search ${label}`}
                      />
                      {/* Hide merge organization for now as it will require additional changes due to SOWs now. */}
                      {/* <MergeOrganization
                  updateOrganizationList={updateOrganizationList}
                /> */}
                      {!isArchivedTab && (
                        <Button
                          className='text-uppercase ml-4 s8 line-height-normal'
                          variant='black'
                          onClick={() => setShowAddCompanyEcoModal(true)}>
                          Add
                        </Button>
                      )}
                    </div>
                  </div>
                )
              }}
              colClasses='px-0'
            />
            <Container
              className='custom-offset-lg-1 custom-col-lg-12 px-0 mb-2-5 mt-2-5'
              fluid>
              <NavTabs
                pages={listingPages}
                pathname={location?.pathname}
                hash={location?.hash}
                NavLink={NavLink}
              />
            </Container>
            <UpsertCompanyEcoModal
              show={showAddCompanyEcoModal}
              onHide={() => {
                setShowAddCompanyEcoModal(false)
              }}
              type={type}
            />
            <Container
              className='mt-3 custom-offset-lg-1 custom-col-lg-12 px-0'
              fluid>
              <Table
                ref={hasMore}
                emptyTableMessage={`No ${sortById?.toLowerCase()} found.`}
                tableInstance={{
                  preGlobalFilteredRows,
                  state: { globalFilter, ...other },
                  setGlobalFilter,
                  ...rest,
                }}
                isLoading={isLoading}
                fetchData={fetchData}
              />
              {/* {isLoadMore && <tr ref={loader}></tr>} */}
            </Container>
          </>
        )}
      </TableInstance>
    </>
  )
}

export default OrgEcoListingTable
